import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();
  // Hide footer on admin routes
  if (pathname.startsWith("/admin")) return null;

  return (
    <footer className="bg-primary text-primary-foreground mt-12">
      <div className="container-comfortable py-8">
        <nav
          aria-label="Rechtliche Hinweise"
          className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-base md:text-lg"
        >
          <Link to="/impressum" className="underline hover:text-accent transition-colors">
            Impressum
          </Link>
          <Link to="/datenschutz" className="underline hover:text-accent transition-colors">
            Datenschutz
          </Link>
          <Link to="/agb" className="underline hover:text-accent transition-colors">
            AGB
          </Link>
        </nav>
        <p className="text-center text-sm md:text-base text-primary-foreground/80 mt-4">
          © {new Date().getFullYear()} Rente Plus Immobilie
        </p>
      </div>
    </footer>
  );
};

export default Footer;
